import script from "./flylog-group.vue?vue&type=script&lang=ts&setup=true"
export * from "./flylog-group.vue?vue&type=script&lang=ts&setup=true"

import "./flylog-group.vue?vue&type=style&index=0&id=4f5e5e1c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5e5e1c"]])

export default __exports__